var userEmail = ''

exports.email = userEmail
